import { Box, Button, customStyled } from '@mafc/trolly';

export const ReadAboutButton = customStyled(Button)((props: any) => ({
  fontWeight: props.theme.fontWeights[8],
  marginBottom: props.theme.space[3],
  display: 'flex',
  height: 'auto',
}));

export const ReadAboutText = customStyled(Box)((props: any) => ({
  marginRight: props.theme.space[2],
}));
